import { ProfessionnelItem } from './professionnel-item';

export class ConditionProfessionnel
{
    id: number|undefined;
    code:String;
    label:String;
    checked:Boolean;
    isDeleted:Boolean;
    createBy:String;
    createAt:String;
    updateBy:String;
    updateAt:String;
    professionnelItem:ProfessionnelItem;
}